import { useState } from "react";
import useTranslations from "../../core/i18n/useTranslations";
import { notifyApiErrors } from "../../core/helpers/helpers";
import PrimeModal from "../../ui-lib/components/PrimeModal/PrimeModal";

export const RemoveFromObjectModal = ({
  isOpen,
  header,
  description,
  submitBtnText,
  onConfirm,
  onClose,
}: {
  isOpen: boolean;
  header: string;
  description: string;
  submitBtnText: string;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}) => {
  const t = useTranslations();

  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      await onConfirm();
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PrimeModal
      withFooter
      withHeader
      isOpen={isOpen}
      onClose={onClose}
      fixedWidth="576px"
      loading={isLoading}
      header={header}
      submitBtn={{
        text: submitBtnText,
        variant: "primary",
        onClick: handleConfirm,
        disabled: isLoading,
      }}
      cancelBtn={{ text: t("Common:cancel"), onClick: onClose }}
    >
      <p style={{ color: "var(--Grey-600)" }}>
        {t("Objects:remove_from_object_description").replace(
          "{#}",
          description,
        )}
      </p>
    </PrimeModal>
  );
};
